import Column from '@components/column'
import Row from '@components/row'
import Image from '@components/image'
import Fields from '@components/fields'
import { Constant } from '@utils'
import { styleInputWrapper, styleRow } from './style'
import { useSelector } from 'react-redux'
import { Category } from '@apis'
import { useEffect } from 'react'
import Typography from '@components/typography'
const PatientStep2Form = () => {
  const { data: symptoms } = useSelector((state: any) => state.symptoms)

  const fetchSymptoms = async () => {
    await Category.list({
      state: 'symptoms',
      params: {
        type: 'Symptom',
      },
    }).catch(() => {})
  }
  useEffect(() => {
    if (!symptoms?.length) {
      fetchSymptoms()
    }
  }, [])

  return (
    <Column rowGap={15}>
      <Column alignItems="center">
        <Fields.Upload varient="avatar" name="avatar" size={90} />
      </Column>
      <Row justifyContent="space-between" styleRow={styleRow}>
        <Fields.ChooseButton
          name="gender"
          label="Gender"
          items={Constant.genders}
          titleAsKey="name"
          valueAsKey="value"
          multiple={false}
        />

        <Fields.Input
          type="number"
          name="age"
          label="Age"
          placeholder="Age"
          styleWrapper={styleInputWrapper}
        />
      </Row>
      <Fields.ChooseButton
        items={Constant.bloodGroups}
        name="bloodGroup"
        titleAsKey="name"
        valueAsKey="value"
        label="Blood Group"
        multiple={false}
      />
      <Fields.ChooseButton
        name="symptoms"
        label="Health Problems"
        styleButton="
          height:auto;
          border:0px;
        "
        items={symptoms?.map((symptom) => {
          return {
            id: symptom?.id,
            name: symptom?.name,
            render: () => {
              return (
                <Column rowGap={10} styleColumn="padding:5px 0px;">
                  <Image
                    src={`${process.env.BUCKET_URL}/${symptom?.infos?.image}`}
                    height={50}
                    width={50}
                  />
                  <Typography content={symptom?.name} size={14} />
                </Column>
              )
            },
          }
        })}
        titleAsKey="name"
        valueAsKey="id"
      />
    </Column>
  )
}

export default PatientStep2Form
